module.exports = __webpack_public_path__ + "media/images/logo_harfang_immigration-8fbd6b89d0b4ae3cdba4106e6f0dfa89.png";